import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const LogoutButton = () => {
  const navigate = useNavigate();

  // Auto-logout when tab/browser closes
  useEffect(() => {
    const handleUnload = () => {
      sessionStorage.removeItem("user");
      localStorage.removeItem("token"); // Optional: remove token
      navigator.sendBeacon(`${API_BASE}/api/auth/logout`);
    };

    window.addEventListener("unload", handleUnload);
    return () => window.removeEventListener("unload", handleUnload);
  }, []);

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: "POST",
      });

      sessionStorage.removeItem("user");
      localStorage.removeItem("token"); // Optional
      navigate("/login");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="text-white bg-red-600 hover:bg-red-700 px-4 py-1 rounded"
    >
      Logout
    </button>
  );
};

export default LogoutButton;
